const _ = require('lodash');
import { loaderStrategy } from '../configs/Config';

const getQueryParameterByName = require('../helpers/GetQueryParam');

let Loader;
let DevLoader;
let VendorLoader;

const localeMap = {
  en: 'en_US',
  fr: 'fr_CA',
  en_US: 'en_US',
  fr_CA: 'fr_CA'
};

// Function to get value by key
function getLocaleValue(key) {
  if (localeMap.hasOwnProperty(key)) {
      return localeMap[key];
  }
  return localeMap['en_US'];
}

// Allow loading from query params if not in production
if (!__PROD__) {
  DevLoader = require('./dev.js');
}

if (loaderStrategy !== 'default') {
  VendorLoader = require(`./${loaderStrategy}.js`);
}

function getAttributeFromUcLoader(attr) {
  return document.getElementById('uc-loader').getAttribute(attr) || undefined;
}

const authKey = getAttributeFromUcLoader('data-auth-key');
const addToCartUrl = getAttributeFromUcLoader('data-cart-url');
const productId = getAttributeFromUcLoader('data-product-id');
const configId = getAttributeFromUcLoader('data-config-id') || getQueryParameterByName('config');
const ln = getLocaleValue(getAttributeFromUcLoader('data-product-lang') || getQueryParameterByName('lang') || 'en');
const addConfigToCart = getAttributeFromUcLoader('data-add-to-cart');
const defaultValues = getQueryParameterByName('uc_default_values');

const BaseLoader = {
  authKey,
  addToCartUrl,
  productId,
  configId,
  addConfigToCart,
  defaultValues,
  ln
};

// Load vendor params unless we're using the default strategy
if (loaderStrategy !== 'default') {
  Loader = _.merge(BaseLoader, VendorLoader, DevLoader);
} else {
  Loader = _.merge(BaseLoader, DevLoader);
}

var copyLoader = _.cloneDeep(Loader);
console.log('BaseLoader', BaseLoader)
console.log('DevLoader', DevLoader)
console.log('copyLoader', copyLoader)
if (copyLoader.authKey != undefined) delete copyLoader.authKey;
if (copyLoader.addToCartUrl != undefined) delete copyLoader.addToCartUrl;

console.log('whole loader: ', copyLoader);

export default Loader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/index.js